<template>
  <div class="tab-panel-content">
    <div class="station-layout">
      <div class="station-list">
        <div class="search">
          <el-input v-model="stationSearch" placeholder="搜索电站..." clearable size="small" prefix-icon="Search" />
        </div>
        <div class="items">
          <div
            v-for="s in filteredStations"
            :key="s.id"
            class="s-item"
            :class="{ active: selectedStation && selectedStation.id === s.id }"
            @click="selectStation(s)"
          >
            <span class="mdi mdi-office-building-outline s-icon" style="color: var(--primary)"></span>
            <span class="s-name">{{ s.name }}</span>
            <span class="s-count">{{ enabledCount(s) }}/{{ allAlarmTypes.length }}</span>
          </div>
        </div>
      </div>
      <div v-if="selectedStation" class="station-detail">
        <div class="sd-header">
          <div class="sd-title">{{ selectedStation.name }} <small>ID: {{ selectedStation.id }}</small></div>
          <div style="display: flex; gap: 6px">
            <!-- <el-button size="small" type="success" plain @click="toggleAll(true)">全开</el-button>
            <el-button size="small" type="danger" plain @click="toggleAll(false)">全关</el-button> -->
            <v-btn size="small" variant="flat" color="success" plain :disabled="!canEditStationSwitch" @click="handleToggleAll(true)">全开</v-btn>
            <v-btn size="small" variant="flat" color="info" plain :disabled="!canEditStationSwitch" @click="handleToggleAll(false)">全关</v-btn>
            <!-- <el-button size="small" type="primary" @click="saveStationConfig">保存</el-button> -->
          </div>
        </div>
        <div class="sd-body">
          <div v-for="cat in alarmCategories" :key="cat.key" class="alarm-cat-group">
            <div class="acg-head">
              <span class="cat-dot" :style="{ background: 'var(--cat-' + cat.key + ')' }"></span>
              <span class="acg-name">{{ cat.name }}</span>
              <span class="acg-count">{{ catEnabledCount(cat.key) }}/{{ categoryAlarms(cat.key).length }}</span>
            </div>
            <div
              v-for="alarm in categoryAlarms(cat.key)"
              :key="alarm.code"
              class="alarm-row"
              :class="{ on: curAlarms[alarm.code], off: !curAlarms[alarm.code] }"
            >
              <div class="ar-info">
                <div class="ar-name">{{ alarm.name }}</div>
                <div class="ar-desc">{{ alarm.desc }}</div>
              </div>
              <span class="ar-code">{{ alarm.code }}</span>
              <span class="ar-st" :class="curAlarms[alarm.code] ? 'on' : 'off'">
                {{ curAlarms[alarm.code] ? '已开启' : '已关闭' }}
              </span>
              <el-switch v-model="curAlarms[alarm.code]" :disabled="!canEditStationSwitch" />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="station-detail station-detail-empty">
        <span class="mdi mdi-arrow-left" style="margin-right: 6px"></span> 请先选择左侧电站
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAlarmConfig } from '../useAlarmConfig'
import { checkPermi } from '@/utils/permission'
import { computed } from 'vue'

const {
  alarmCategories,
  allAlarmTypes,
  categoryAlarms,
  stationSearch,
  selectedStation,
  curAlarms,
  filteredStations,
  selectStation,
  enabledCount,
  catEnabledCount,
  toggleAll,
  saveStationConfig,
} = useAlarmConfig()

const canEditStationSwitch = computed(() => checkPermi(['ops:alarmConfig:stationSwitch']))

function handleToggleAll(enabled) {
  if (!canEditStationSwitch.value) return
  toggleAll(enabled)
}
</script>

<style scoped lang="scss">
.station-layout {
  display: flex;
  gap: 16px;
  min-height: 480px;
}

.station-list {
  width: 260px;
  flex-shrink: 0;
  background: var(--card-bg);
  border-radius: 12px;
  border: 1px solid #fff;
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  backdrop-filter: blur(6px);
}

.station-list .search {
  padding: 12px;
  border-bottom: 1px solid var(--color-td-border);
}

.station-list .items {
  flex: 1;
  overflow-y: auto;
  max-height: 420px;
}

.s-item {
  padding: 11px 14px;
  cursor: pointer;
  border-bottom: 1px solid var(--color-td-border);
  transition: background 0.15s ease;
  display: flex;
  align-items: center;
  gap: 10px;
}

.s-item:hover {
  background: var(--primary-faint);
}

.s-item.active {
  background: var(--primary-light);
  border-left: 3px solid var(--primary);
}

.s-item .s-icon {
  font-size: 18px;
}

.s-item .s-name {
  font-size: 13px;
  color: var(--text-primary);
  flex: 1;
}

.s-item .s-count {
  font-size: 11px;
  padding: 1px 8px;
  border-radius: 8px;
  background: var(--surface-muted);
  color: var(--text-muted);
}

.s-item.active .s-count {
  background: color-mix(in srgb, var(--color-primary) 18%, #e8eefc);
  color: var(--primary);
}

.station-detail {
  flex: 1;
  background: var(--card-bg);
  border-radius: 12px;
  border: 1px solid #fff;
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  backdrop-filter: blur(6px);
}

.station-detail-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
}

.sd-header {
  padding: 14px 20px;
  border-bottom: 1px solid var(--color-td-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sd-header .sd-title {
  font-size: 15px;
  font-weight: 600;
}

.sd-header .sd-title small {
  font-size: 12px;
  color: var(--text-muted);
  font-weight: 400;
  margin-left: 6px;
}

.sd-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
  max-height: 420px;
}

.alarm-cat-group {
  margin-bottom: 20px;
}

.alarm-cat-group .acg-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--color-td-border);
}

.cat-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.alarm-cat-group .acg-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.alarm-cat-group .acg-count {
  font-size: 12px;
  color: var(--text-muted);
}

.alarm-row {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border-radius: 10px;
  margin-bottom: 6px;
  border: 1px solid transparent;
  transition:
    background 0.2s ease,
    border-color 0.2s ease;
}

.alarm-row:hover {
  background: color-mix(in srgb, var(--color-text) 4%, #ffffff);
}

.alarm-row.on {
  background: color-mix(in srgb, var(--color-success) 10%, #ffffff);
  border-color: color-mix(in srgb, var(--color-success) 32%, #ffffff);
}

.alarm-row.off {
  background: color-mix(in srgb, var(--color-error) 8%, #ffffff);
  border-color: color-mix(in srgb, var(--color-error) 22%, #ffffff);
}

.alarm-row .ar-info {
  flex: 1;
}

.alarm-row .ar-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
}

.alarm-row .ar-desc {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 2px;
}

.alarm-row .ar-code {
  font-size: 11px;
  color: var(--text-muted);
  font-family: monospace;
  margin-right: 14px;
}

.alarm-row .ar-st {
  font-size: 12px;
  margin-right: 10px;
}

.alarm-row .ar-st.on {
  color: var(--success);
}

.alarm-row .ar-st.off {
  color: var(--danger);
}

@media (prefers-reduced-motion: reduce) {
  .alarm-row,
  .s-item {
    transition: none;
  }
}

@media (max-width: 960px) {
  .station-layout {
    flex-direction: column;
  }

  .station-list {
    width: 100%;
    max-height: 280px;
  }
}
</style>
